import React from 'react'
import { Row, Col } from "reactstrap";
import Dropdown from '../../components/Dropdown';
import Attendance_BarChart from './demoChart/Attendance_BarChart'

export default function Attendance() {
  return (
    <Row>
          <div className="box-graph-total">
          <br />
          <Row>
            <Col xs={12} sm={12} md={4} lg={4} xl={4}>
              <p className="text-header-total-dashboard-sm-graph-by-nile">
              Attendance
              </p>
              <Dropdown
                items={["2565", "2564", "2563"]}
                // styles={{ marginBottom : "50px" }}
                itemCallback={(item) => {}}
              />
              <br />
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4}>
              <p className="text-header-total-dashboard-lg-graph-by-nile">
              Attendance
              </p>
            </Col>
            <Col xs={0} sm={0} md={4} lg={4} xl={4} />
          </Row>
          <Row>
            <Col >
            <Attendance_BarChart />
            </Col>
          </Row>
          <br />
        </div>
      </Row>
  )
}